import { CalculatorPreviewTileProps } from '.'
import { DebtConsolidationMan } from 'experiences/learn/topics/CalculatorPreviewTile/graphic'

export const CalculatorPreviewTileData: CalculatorPreviewTileProps = {
	sectionTitle: 'Calculator',
	image: DebtConsolidationMan,
	title: 'See how much you could save!',
	subTitle: "It's fast, easy and free. With no risk to your credit.",
	text: 'Our debt consolidation calculator lets you enter your current outstanding debt, average interest and monthly payment, then finds offers on our network to see how much you could save each month by taking out a personal loan.',
	path: '/tools/debt-consolidation-calculator'
}
